import { memo } from 'react';
import { css } from '@emotion/react';
import { EdgeProps, getBezierPath, EdgeLabelRenderer } from 'reactflow';
import { color, typography } from '@uniquegood/realworld-studio-design';

function FlowEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  style
}: EdgeProps) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition
  });

  return (
    <>
      <defs>
        <marker
          id={`arrowhead-${id}`}
          markerWidth="12"
          markerHeight="8"
          refX="10"
          refY="4"
          orient="auto"
        >
          <path d="M0,0 L12,4 L0,8 Z" fill={color.action_primary_default} />
        </marker>
      </defs>
      <path
        id={id}
        css={EdgePathStyle}
        d={edgePath}
        markerEnd={`url(#arrowhead-${id})`}
        style={style}
      />
      <EdgeLabelRenderer>
        <div
          css={EdgeLabelStyle}
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`
          }}
        >
          {data?.label ?? 'NEXT'}
        </div>
      </EdgeLabelRenderer>
    </>
  );
}

export default memo(FlowEdge);

const EdgePathStyle = css`
  stroke: ${color.action_primary_default};
  stroke-width: 2;
  fill: none;
`;

const EdgeLabelStyle = css`
  position: absolute;
  pointer-events: none;
  font-size: 10px;
  font-weight: ${typography.weight.bold};
  color: ${color.text_disabled};
  letter-spacing: 0.08em;
  background-color: ${color.surface_default_default};
  padding: 2px 6px;
  border-radius: 4px;
`;
